
import { Options, Vue } from "vue-class-component";

@Options({
  props: ["show", "message"],
})
export default class Loader extends Vue {
}
